import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import {
  fetchChannels,
  getFavoriteChannelIds,
  getRecentChannelIds,
} from "./channelScheduleApi";
import "./BroadcastStudio.css";
import "./ChannelDirectoryPage.css";

/**
 * Channel directory — favorites, recent, full lineup.
 */
function ChannelDirectoryPage() {
  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(true);
  const favs = getFavoriteChannelIds();
  const recent = getRecentChannelIds();

  useEffect(() => {
    (async () => {
      setLoading(true);
      const list = await fetchChannels({ visibility: "public" });
      setChannels(list);
      setLoading(false);
    })();
  }, []);

  const byId = (id) =>
    channels.find((c) => String(c.id) === String(id) || String(c.unique_id) === String(id));

  const section = (title, ids) => {
    const rows = ids.map(byId).filter(Boolean);
    if (!rows.length) return null;
    return (
      <section className="channel-dir__section">
        <h2>{title}</h2>
        <div className="channel-dir__grid">
          {rows.map((c) => (
            <Link key={c.id} className="channel-dir__card" to={"/channels/" + (c.slug || c.unique_id)}>
              <div
                className="channel-dir__art"
                style={
                  c.banner || c.logo
                    ? {
                        backgroundImage:
                          "url(" + (c.banner || c.logo) + ")",
                      }
                    : undefined
                }
              >
                {c.logo ? (
                  <img src={c.logo} alt="" className="channel-dir__logo" />
                ) : (
                  <div className="channel-dir__ph" />
                )}
                <span className="channel-dir__live">LIVE</span>
              </div>
              <strong>{c.name}</strong>
              <span>{c.description || c.kind || "Channel"}</span>
            </Link>
          ))}
        </div>
      </section>
    );
  };

  return (
    <div className="bcast-studio">
      <Helmet>
        <title>Channels · TPG</title>
      </Helmet>
      <header className="bcast-studio__header">
        <div>
          <p className="bcast-studio__eyebrow">Multi-Channel Lineup</p>
          <h1>Channels</h1>
        </div>
        <nav className="bcast-studio__nav">
          <Link to="/guide">What&apos;s On</Link>
          <Link to="/studio/timeline">Timeline Studio</Link>
        </nav>
      </header>

      {loading && <p className="bcast-studio__status">Loading channels…</p>}
      {section("Favorites", favs)}
      {section("Recently watched", recent)}

      <section className="channel-dir__section">
        <h2>All channels</h2>
        <div className="channel-dir__grid">
          {channels.map((c) => (
            <Link key={c.id} className="channel-dir__card" to={"/channels/" + (c.slug || c.unique_id)}>
              <div
                className="channel-dir__art"
                style={
                  c.banner || c.logo
                    ? {
                        backgroundImage:
                          "url(" + (c.banner || c.logo) + ")",
                      }
                    : undefined
                }
              >
                {c.logo ? (
                  <img src={c.logo} alt="" className="channel-dir__logo" />
                ) : (
                  <div className="channel-dir__ph" />
                )}
              </div>
              <strong>
                {c.channel_number != null ? "#" + c.channel_number + " " : ""}
                {c.name}
              </strong>
              <span>{c.description || c.category || c.kind || "Channel"}</span>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}

export default ChannelDirectoryPage;
